import { LitElement } from "lit";

/**
 * Disable shadow root for web component
 *
 */
export default class WeView extends LitElement {
	createRenderRoot() {
		return this;
	}
}
